import { render } from "./PlanItemFree.vue?vue&type=template&id=34726a1c"
import script from "./PlanItemFree.vue?vue&type=script&lang=js"
export * from "./PlanItemFree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/onboarding/PlanItemFree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34726a1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34726a1c', __exports__)) {
    api.reload('34726a1c', __exports__)
  }
  
  module.hot.accept("./PlanItemFree.vue?vue&type=template&id=34726a1c", () => {
    api.rerender('34726a1c', render)
  })

}


export default __exports__